import { render } from "./Discount.vue?vue&type=template&id=9e70a49c&scoped=true"
import script from "./Discount.vue?vue&type=script&lang=ts"
export * from "./Discount.vue?vue&type=script&lang=ts"

import "./Discount.vue?vue&type=style&index=0&id=9e70a49c&lang=sass&scoped=true"
script.render = render
script.__scopeId = "data-v-9e70a49c"

export default script